import { Spinner } from './Spinner';

export function Loading() {
  return (
    <div className="wrapper d-flex align-items-center justify-content-center">
      <Spinner />
    </div>
  );
}
